import * as React from "react"
import { Grid } from "@mui/material"

import UserActivitiesTopCountries from "./Countries"
import UserActivitiesTopDashboards from "./Dashboards"
import UserActivitiesTopTabs from "./Tabs"
import UserActivitiesTopUsers from "./Users"
import UserActivitiesTopCustomers from "./Customers"

export default function UserActivitiesTop() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <UserActivitiesTopTabs />
        </Grid>

        <UserActivitiesTopCountries />
        <UserActivitiesTopUsers />
        <UserActivitiesTopDashboards />
        <UserActivitiesTopCustomers />
    </Grid>
}